import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from 'date-fns/locale';

import App from './app/App';

import "./styles/styles.scss";

Sentry.init({
	dsn: "https://5e86b3242e214e9fbadf0f90b6ea0316@o1334249.ingest.sentry.io/6600544",
	integrations: [new BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 0,
});

ReactDOM.render(
	<React.StrictMode>
		<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
			<App/>
		</LocalizationProvider>
	</React.StrictMode>,
	document.getElementById('root')
);
